import { filter } from 'rxjs/operators';
import { Component, inject, input, output, signal } from '@angular/core';
import { DocumentiService } from 'src/app/core/documenti.service';
import { DocumentiListColumnNames } from 'src/app/shared/components/documenti-list/documenti-list.model';
import { DocumentiSearchDocRow, DocumentiSearchFilters, DocumentiSearchRequest, DocumentiSearchResponse } from 'src/app/shared/models/documento-search.model';
import { Posizione } from 'src/app/shared/models/posizione.model';
import { DocumentoOperazioniMassive } from '../../models/operazioni-massive.model';

@Component({
  selector: 'app-ricerca-documenti',
  template: `
    <p-accordion [activeIndex]="searchTabActive()" (activeIndexChange)="searchTabActiveChange($event)">
      <p-accordionTab header="Parametri">
        <app-intestazione-ricerca (onSearch)="search($event)"></app-intestazione-ricerca>
      </p-accordionTab>
      <p-accordionTab header="Risultati">
        <div class="grid nested-grid">
          <div class="col-6">
            <div class="col-12 h-table">
              <app-documenti-list id="searchresult" [showActionButtons]="false" [allowCheckBoxSelection]="true" (rowSelected)="documentToSelect($event)" 
                [showRowsPerPage]="false" [data]="searchResponse" [activeColumns]="columns"></app-documenti-list>
            </div>
            <div class="col-12"> 
              <app-item-selected-summary [numSelected]="searchResponse?.results?.length" type="searched"></app-item-selected-summary>
            </div>            
          </div>
          <div class="col-offset-1 col-5">
             <div class="col-12 h-table">
              <app-documenti-selected-list id="selectedresult"  [data]="selectedDocuments()" (unselected)="removeSelectedDocument($event)"></app-documenti-selected-list>
            </div>
            <div class="col-12"> 
              <app-item-selected-summary [numSelected]="selectedDocuments().length" type="selected"></app-item-selected-summary>     
            </div>              
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  `,
  styles:`.h-table { height: 39rem;}`
})
export class RicercaDocumentiComponent {

  private readonly documentiService = inject(DocumentiService);

  private readonly PAGE_SIZE = -1;

  baseRequest = input<DocumentiSearchRequest | undefined>(undefined);
  selected = output<DocumentiSearchDocRow[]>();

  public selectedDocuments = signal<DocumentiSearchDocRow[]>([]);
  public currentDocuments: DocumentiSearchDocRow[] = [];

  public searchResponse = {
    originalRequest: { pageFirstRow: 0, pageSize: this.PAGE_SIZE, sortField: 'protocollo', sortOrder: -1 }
  } as DocumentiSearchResponse;

  public columns: DocumentiListColumnNames = ['Protocollo', 'Classifica', 'Arrivo', 'Oggetto', 'Note'];
  public searchTabActive = signal<number | number[] | undefined>(0);

  private readonly EMPTY_REQUEST = {
    pageFirstRow: 0,
    includeAllegati: false,
    pageSize: this.PAGE_SIZE,
    sortField: 'Protocollo',
    sortOrder: -1,
    filters: {
      posizioneId: null,
      posizioneDescrizione: null,
      protocollo: null,
      oggetto: null,
      dataDocumento: null,
      dataDal: null,
      dataAl: null,
      dataProtocolloDal: null,
      dataProtocolloAl: null,
      dataProtocollazione: null,
      mittenteId: null,
      protocolloMittente: null,
      statoId: null,
      statoUtente: null,
      classificaId: null,
      esercitazione: null,
      qualificaId: null,
      sezioneId: null,
      nomeAllegato: null,
    } as DocumentiSearchFilters
  } as DocumentiSearchRequest;


  public search(searchParameter: DocumentoOperazioniMassive): void {

    const request = { ...this.EMPTY_REQUEST, ... this.baseRequest() };

    request.filters = {
      ...request.filters,
      posizioneId: (searchParameter.posizione.length) ? this.calcolaPosizione(searchParameter.posizione) : null,
      protocollo: searchParameter.protocollo,
      dataDal: (searchParameter.dataDocumento?.length) ? searchParameter.dataDocumento[0] : null,
      dataAl: this.dataAl(searchParameter.dataDocumento),
    }
    this.currentDocuments = [];
    request.pageSize = this.PAGE_SIZE;

    this.documentiService.search(request, true).subscribe(response => {
      this.searchResponse = response;
      this.searchTabActive.set(1);
      setTimeout(() => {
        const $searchresult = window.document.getElementById('searchresult');
        $searchresult?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      }, 100);
    });
  }

  public documentToSelect(value: DocumentiSearchDocRow | DocumentiSearchDocRow[]): void {
    if (Array.isArray(value)) {

      this.currentDocuments.forEach( i=> {
        const toBeDeleted = (value.filter( x=> x.documentoId == i.documentoId).length === 0);
        if (toBeDeleted) {  
            this.selectedDocuments.update( selected => [...selected.filter( x=> x.documentoId != i.documentoId)]);
        }
      });

      this.currentDocuments = [...value];

      this.selectedDocuments.update( selected => [ ... selected.concat(this.currentDocuments.filter( x=> selected.filter( s=> s.documentoId ===  x.documentoId).length === 0 ))] );
      this.selected.emit(this.selectedDocuments());
    } else {
      this.currentDocuments = [value];
    }
  }

  public removeSelectedDocument(item: DocumentiSearchDocRow): void {
    if (this.selectedDocuments().length) {
      this.selectedDocuments.update( selected =>  [... selected.filter(e => (e.documentoId != item.documentoId))]);
      this.selected.emit(this.selectedDocuments());
    }
  }

  public searchTabActiveChange(index: number | number[]): void {
    this.searchTabActive.set(index);
  }

  private dataAl(values: Date[] | null): Date | null {
    if (!values) return null;
    return values[1] ?? values[0];
  }

  private calcolaPosizione(posizione: Posizione[]): string {
    let pos = '/';
    if (posizione.length !== 0) {
      posizione.forEach((fasc: Posizione) => {
        if (fasc !== null) {
          pos = fasc.posizioneId;
        }
      });
    }
    return pos;
  }
}
